import { render, staticRenderFns } from "./TaxStat.vue?vue&type=template&id=bd712fc8"
import script from "./TaxStat.vue?vue&type=script&lang=js"
export * from "./TaxStat.vue?vue&type=script&lang=js"
import style0 from "./TaxStat.vue?vue&type=style&index=0&id=bd712fc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports